import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FullWidthCarousel from 'LuxKit/Carousel/FullWidthCarousel'
import HotelPageSearchHotelCategoryTile from './HotelPageSearchHotelCategoryTile'
import type { CategoryData } from './types'
import styled from 'styled-components'
import { rem } from 'polished'
import { ANYWHERE_NAME, ANYWHERE_PLACE_ID } from 'constants/search'

const Root = styled.div`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

function HotelPageDestinationTiles() {
  const intl = useIntl()

  const headingText = useMemo(() => {
    return intl.formatMessage(
      {
        id: 'BrKQB1Zzgq',
        defaultMessage: 'Discover <i>your</i> ideal escape',
        description: 'Heading for hotel categories carousel',
      },
      {
        i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
      },
    )
  }, [intl])

  const categories: Array<CategoryData> = useMemo(() => [
    {
      id: 'city_break',
      name: intl.formatMessage({
        id: 'DK9Qgi/qFf',
        defaultMessage: 'City breaks',
        description: 'City breaks category name',
      }),
      imageId: 'hotel-category-tile-city-break',
      show: true,
      parameterName: 'holidayTypes',
      parameterValue: 'City Break',
    },
    {
      id: 'sun_beach',
      name: intl.formatMessage({
        id: 'rfpRkbHcEM',
        defaultMessage: 'Sun & Beach',
        description: 'Sun & Beach category name',
      }),
      imageId: 'hotel-category-tile-sun-beach',
      show: true,
      parameterName: 'holidayTypes',
      parameterValue: 'Sun & Beach',
    },
    {
      id: 'private_pool',
      name: intl.formatMessage({
        id: 'SRg29q1xtX',
        defaultMessage: 'Private pool',
        description: 'Private pool category name',
      }),
      imageId: 'hotel-category-tile-private-pool',
      show: true,
      parameterName: 'amenities',
      parameterValue: 'Private pool',
    },
    {
      id: 'unique_stays',
      name: intl.formatMessage({
        id: 'DBsIwPBOcC',
        defaultMessage: 'Unique stays',
        description: 'Unique stays category name',
      }),
      imageId: 'hotel-category-unique-stays',
      show: true,
      parameterName: 'holidayTypes',
      parameterValue: 'Unique Stays',
    },
    {
      id: 'spa_break',
      name: intl.formatMessage({
        id: 'ExIyDCgjvX',
        defaultMessage: 'Spa break',
        description: 'Spa break category name',
      }),
      imageId: 'hotel-category-tile-spa-break',
      show: true,
      parameterName: 'holidayTypes',
      parameterValue: 'Spa Break',
    },
    {
      id: 'romantic',
      name: intl.formatMessage({
        id: 'VN/VXJXL2F',
        defaultMessage: 'Romantic',
        description: 'Romantic category name',
      }),
      imageId: 'hotel-category-tile-romantic-2',
      show: true,
      parameterName: 'holidayTypes',
      parameterValue: 'Romantic',
    },
    {
      id: 'homes_and_villas',
      name: intl.formatMessage({
        id: 'g8yz8nSg0A',
        defaultMessage: 'Homes & Villas',
        description: 'Homes & Villas category name',
      }),
      imageId: 'c9f8da1e-439a-4301-9a5d-0ec10be87ba7',
      show: true,
      parameterName: 'link',
      parameterValue: `/search/homes-and-villas?destinationId=${ANYWHERE_PLACE_ID}&destinationName=${ANYWHERE_NAME}&adults=2&children=none`,
    },
  ], [intl])

  return (
    <Root>
      <VerticalSpacer gap={20}>
        <LayoutContainer>
          <Heading variant="heading2">
            {headingText}
          </Heading>
        </LayoutContainer>
        <FullWidthCarousel snap="start" itemsPerArrow={6}>
          {categories.map(category => {
            return <HotelPageSearchHotelCategoryTile key={category.id} category={category} />
          })}
        </FullWidthCarousel>
      </VerticalSpacer>
    </Root>
  )
}

export default HotelPageDestinationTiles
